import { ADMIN_PARK_LIST } from './index';
import { Action } from '../action';

export class AdminParkListInitAction implements Action {
	readonly type = ADMIN_PARK_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminParkListDestroyAction implements Action {
	readonly type = ADMIN_PARK_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
